import axios from 'axios'

// Note: Version endpoint is at root level, not under /api/v1
// We need to remove /api/v1 from the base URL since version is at root
const getBaseUrl = () => {
	const envUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'
	// Remove /api/v1 suffix if present to get the root URL
	return envUrl.replace(/\/api\/v1$/, '')
}

const API_BASE_URL = getBaseUrl()

/**
 * Fetches the current application version from the backend.
 * This is a public endpoint that doesn't require authentication.
 * @returns {Promise<string>} - A promise that resolves to the version string.
 */
export const getAppVersion = async () => {
	try {
		// Version endpoint is public - no authentication needed
		const response = await axios.get(`${API_BASE_URL}/version`)

		console.log('Version response:', response.data)
		// Handle both string and object responses for backward compatibility
		return typeof response.data === 'string'
			? response.data
			: response.data.version
	} catch (error) {
		console.error('Error fetching app version:', error)
		console.error('API_BASE_URL:', API_BASE_URL)
		console.error('Full URL attempted:', `${API_BASE_URL}/version`)

		// Return fallback version if the API call fails
		return 'unknown'
	}
}
